import { Box, Button, Stack } from "@mui/material";
import { forwardRef } from "react";
import TextTruncate from "../TextTruncate";

const CheckoutButton = forwardRef((props, ref) => {
  const { label, text, startIcon, endIcon, keepVisible = 'label', children, stackStyles = {}, ...restProps } = props;
  return (
    <Button variant="checkout" ref={ref} {...restProps} data-keep-visible={keepVisible}>
      <Stack direction={'row'} alignItems={"center"} {...stackStyles}>
        <Box display="flex" className="CheckoutButton-StartIcon">
          {startIcon}
        </Box>
        <Stack direction={"column"} alignItems={"start"}>
          <Box className="label" component={"strong"} lineHeight={1}>
            {label}
          </Box>
          <TextTruncate className="text">
            {text}
          </TextTruncate>
        </Stack>
        <Box display="flex" className="CheckoutButton-EndIcon">
          {endIcon}
        </Box>
      </Stack>
    </Button>
  );
});

export default CheckoutButton;